// @flow

import { Component } from 'react';
import * as React from 'react';
import { Provider } from 'react-redux';

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import createSagaMiddleware from 'redux-saga';

type Props = {
  name: string,
  store: Function,
  saga: Function,
  children: React.Element<any>,
};

const nullReducer = () => null;

export default class ReduxStore extends Component<Props> {
  constructor(props: Props, context) {
    super(props, context);

    const sagaMiddleware = createSagaMiddleware();
    const devToolsEnhancer = composeWithDevTools({
      name: this.props.name,
    });
    const enhancer = devToolsEnhancer(applyMiddleware(sagaMiddleware));
    const rootReducer = this.props.reducer ? this.props.reducer : nullReducer;
    this.store = createStore(rootReducer, enhancer);

    if (props.saga) {
      this.sagaTask = sagaMiddleware.run(props.saga);
    }
  }

  componentWillUnmount() {
    if (this.sagaTask) {
      this.sagaTask.cancel();
    }
  }

  render() {
    return <Provider store={this.store}>{this.props.children}</Provider>;
  }
}
